export default __webpack_public_path__ + "static/garden_design2-23e1aab4e602ad80321c13c75d8c74f2.webp";